module.exports = __webpack_public_path__ + "img/edit2.ec2826db.svg";